import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import Spacer from '../../../components/presentational/Spacer';

import highlightStyles from './Highlight_styles';

export interface HighlightProps {
  children: React.ReactNode;
  className?: string;
}

const Highlight = ({
  styles,
  children,
  className,
}: HighlightProps & StylesProps<typeof highlightStyles>) => (
  <Spacer className={cx(styles.container, className)} self="xxxs">
    <div className={styles.inner}>{children}</div>
  </Spacer>
);

export default styled(highlightStyles)(Highlight);
